import { render, staticRenderFns } from "./permissList.vue?vue&type=template&id=8ab425f2&"
import script from "./permissList.vue?vue&type=script&lang=js&"
export * from "./permissList.vue?vue&type=script&lang=js&"
import style0 from "./permissList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports